export const apiUrl = process.env.REACT_APP_API_URL;
export const appUrl = process.env.REACT_APP_URL;
export const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const discordClientId = process.env.REACT_APP_DISCORD_CLIENT_ID;
export const instagramClientId = process.env.REACT_APP_INSTAGRAM_CLIENT_ID;
export const tiktokClientId = process.env.REACT_APP_TIKTOK_CLIENT_ID;
export const twitchClientId = process.env.REACT_APP_TWITCH_CLIENT_ID;
export const vimeoClientId = process.env.REACT_APP_VIMEO_CLIENT_ID;
export const facebookClientId = process.env.REACT_APP_FACEBOOK_CLIENT_ID;
export const kickClientId = process.env.REACT_APP_KICK_CLIENT_ID;
